export default __webpack_public_path__ + "static/media/5.901352a5.mp4";